import useApi from 'common/hooks/useApi';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ActionCompleteResponse } from '../../../common/types/ApiResponse';
import SendConfirmationPresenter from './SendConfirmationPresenter';

type SendConfirmationHistory = {
  email: string;
};

function getEmail(
  locationState: SendConfirmationHistory | undefined,
  routeParams: string
) {
  if (locationState && locationState.email) {
    return locationState.email;
  }
  const params = new URLSearchParams(routeParams);
  if (params.has('email')) {
    return params.get('email');
  }

  return null;
}

function SendConfirmationContainer() {
  const { location } = useHistory<SendConfirmationHistory>();
  const [
    { data, loading, error: reqError },
    request,
  ] = useApi<ActionCompleteResponse>({
    url: '/register/confirmProfile',
    method: 'POST',
    bypassTokenCheck: true,
  });
  const email = getEmail(location.state, location.search);

  useEffect(() => {
    if (email) {
      try {
        request({
          email,
          verifyId: '', // endpoint expects empty verifyId for sending of confirmation emails
        });
      } catch (e) {
        console.error(e);
      }
    }
  }, [email, request]);

  const sendEmail = async () => {
    if (!loading && email) {
      await request({
        email,
        verifyId: '',
      });
    }
  };

  let error = null;
  if (reqError) {
    error = reqError;
  } else if (!email) {
    error = 'Link is invalid. Email not found.';
  }

  return (
    <SendConfirmationPresenter
      email={email}
      loading={loading}
      error={error}
      data={data}
      onTryAgainClick={sendEmail}
    />
  );
}

export default SendConfirmationContainer;
